import { add } from 'date-fns';
import React from 'react';
import { Tooltip } from 'react-tooltip'

const BrandListing = ({partnerList, updateStatus, getPartnerById,addDeals}) => {
   
    return (
        <>
        <div className="table-responsive custom-table">
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th >sr. no </th>
                        <th>Logo</th>
                        <th className='deal-name'>Name </th>
                        {/* <th style={{ width: '240px' }}>Email </th>
                        <th>Currency</th> */}
                        <th>Sequence</th>
                        <th className='status'>Status </th>
                        <th className='action'>Action </th>
                    </tr>
                </thead>
                
                <tbody>
                    {partnerList && partnerList.length > 0 ? (
                        partnerList.map((item, i) => {  
                              
                return <tr key={i}>
                            <td>{i+1}</td>
                            <td className='text-center'><img src={item?.logo_path} /> </td>
                            <td className="wrap-string deal-name">{item?.name}</td>
                            {/* <td>{item?.email}</td>
                            <td className='text-center'>{item?.currency}</td> */}
                            <td className='text-center'>{item?.partner_sequence}</td>
                            <td className='text-center status'>
                                <label className="custom-switch">
                                    <input type="checkbox" checked={item?.status === 1} onClick={() => updateStatus(item?.id, item.status === 1 ? 0 : 1)}/>
                                    <span className="slider round"></span>
                                </label>
                            </td>
                            
                            <td className='text-center action'> 
                                <div className="table-icons">
                                    <a data-tooltip-id="my-tooltip-inline" data-tooltip-content="Edit Brand Detail" data-tooltip-place="top">
                                        <i className="fa-regular fa-pen-to-square green" onClick={() => getPartnerById(item?.id)} ></i>
                                    </a>
                                    <a data-tooltip-id="my-tooltip-inline" data-tooltip-content="Deals's Count" data-tooltip-place="top">
                                        <span className="deal-count" > {item?.totalDeal}</span>
                                    </a>
                                    {/* <a data-tooltip-id="my-tooltip-inline" data-tooltip-content="Map Deals" data-tooltip-place="top">
                                    <i className="fa-solid fa-layer-group dark-blue" style={{marginLeft: '10px'}} onClick={() => addDeals(item?.id)} ></i></a> */}
                                </div>
                            </td>
                        </tr>
                    })
                    ): (
                        <tr>
                            <td colSpan={6} className='text-center'>no data </td>
                        </tr>
                    )}
                        
                </tbody>
            </table>
        </div>

        <Tooltip id="my-tooltip-inline" place="top" className="custom-tooltip" />
        </>
    );
};

export default BrandListing;


